import type { ImageAspectRatio } from '@shared/types/image.ts';
import type { TileImage } from '@shared/types/types.ts';

/**
 *
 *
 *
 *
 *
 *
 *
 */
export function isCuttableForLayout(
    cuttable: TileImage['cuttable'],
    aspectRatio: ImageAspectRatio | undefined,
): boolean {
    switch (cuttable) {
        case 'PORTRAIT':
            return aspectRatio === 'portrait';
        case 'LANDSCAPE':
            return aspectRatio === 'landscape' || aspectRatio === 'landscape-two-column';
        case 'SQUARE':
            return aspectRatio === 'quad';
        default:
            return false;
    }
}
